import { css } from "lit";
// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.placement-note{background-color:#f9f9fbd0;border:1px solid #313131;border-radius:.25rem;color:#313131;display:block;font-size:.625rem;margin:.25rem;opacity:.85;padding:0 .25rem;-webkit-text-decoration:underline;text-decoration:underline;text-transform:uppercase;width:max-content}.placement-note:focus,.placement-note:hover{opacity:unset;-webkit-text-decoration:none;text-decoration:none}`, ""]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
